<div class="teams-search-container">
    <mat-toolbar class="team-name-toolbar px-0" fxLayout="row" fxLayoutAlign="space-between center">
        <h2 class="text-darktextcolor font-medium">{{ 'GENERAL.SEARCH' | translate }}</h2>
    </mat-toolbar>
    <div class="team-search-container">
        <div fxLayoutAlign="start center" class="mt-16" fxLayoutGap="30px">
            <app-search-outline [searchInput]="searchInput"></app-search-outline>
        </div>
        <div class="team-search-results-container pr-16" *ngIf="!isLoading; else spinner">
            <div *ngIf="teamsTree?.length; else noSearchResults">
                <div class="pt-24" *ngFor="let teamTree of teamsTree">
                    <div class="team-parent-name mb-12" *ngIf="teamTree.parent">
                        {{ teamTree.parent.name }}
                    </div>
                    <mat-card fxLayout="row" fxLayoutAlign="space-between center" class="mb-8 team-container p-16 mat-elevation-z0" *ngFor="let team of teamTree.teams">
                        <div fxLayout="row" fxLayoutAlign="flex-start center">
                            <div class="custom-avatar-icon mr-8" fxLayoutAlign="center center">
                                <mat-icon svgIcon="team"></mat-icon>
                            </div>
                            <h2>{{ team.name }}</h2>
                        </div>

                        <div fxLayout="row" fxLayoutAlign="flex-start center">
                            <span class="mr-12" *ngIf="team.leaders.length">{{ 'TEAMS.LEAD.LABEL.LEADS' | translate }}</span>
                            <div *ngFor="let leader of team.leaders" class="relative">
                                <img class="avatar" *ngIf="leader.avatar.src; else initials" [alt]="leader.fullName" [src]="leader.avatar.src" />
                                <ng-template #initials>
                                    <div fxLayoutAlign="center center" class="avatar-initials avatar">{{ leader.fullName | initials }}</div>
                                </ng-template>
                                <ng-template [onlineStateIndicator]="leader.isOnline"> </ng-template>
                            </div>
                        </div>

                        <app-white-button [label]="'GENERAL.BUTTON.SEE_MORE'" (onClick)="navigateToTeamPage(team)"></app-white-button>
                    </mat-card>
                </div>
            </div>
            <ng-template #noSearchResults>
                <div fxLayout="column" fxLayoutAlign="space-between center" class="pt-120" *ngIf="searchTerm">
                    <div class="no-results-container mb-32" fxLayout="column" fxLayoutAlign="center center">
                        <mat-icon class="participant-view-illustration mb-8" svgIcon="search_illustration"></mat-icon>
                        <h2>{{ 'GENERAL.LABEL.NO_RESULTS_FOUND' | translate }}</h2>
                        <span>
                            {{ 'GENERAL.LABEL.TRY_SEARCH_SOMETHING_ELSE' | translate }}
                        </span>
                    </div>
                </div>
            </ng-template>
        </div>
        <ng-template #spinner>
            <div class="p-24 pt-120" fxLayoutAlign="center center">
                <mat-spinner></mat-spinner>
            </div>
        </ng-template>

        <div class="mat-paginator-container" [class.hidden]="!teamsTree?.length">
            <mat-paginator persistPageSize="teams.teams-search" [length]="teamsTotalCount$ | async" [pageSize]="5" [pageSizeOptions]="[5, 10, 25]"></mat-paginator>
        </div>
    </div>
</div>
